import type { ElementType, ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import type { DesignSystemAs, DesignSystemElementProps, DesignSystemRef } from "./contracts/dom";

type ContainerElement = "div" | "section" | "main" | "article";

export type ContainerProps<TElement extends ContainerElement = "div"> = {
  children: ReactNode;
  fullWidth?: boolean;
} & DesignSystemAs<TElement> &
  DesignSystemElementProps<TElement> &
  DesignSystemRef<HTMLElementTagNameMap[TElement]>;

/** Establishes the query boundary required by container-responsive layout props. */
export function Container<TElement extends ContainerElement = "div">({
  as,
  children,
  fullWidth = false,
  ref,
  ...nativeProps
}: ContainerProps<TElement>): ReactNode {
  const Element = (as ?? "div") as ElementType;

  return (
    <Element {...nativeProps} ref={ref} className={twJoin("@container", fullWidth && "w-full")}>
      {children}
    </Element>
  );
}
